export const USER_PLAN_FREE = 'free';
export const USER_PLAN_DEMO_PAID = 'demoPaid';
export const USER_PLAN_PREMIUM = 'premium';
